var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex wrap fill fill-h"},[(_vm.$store.state.app.pages['home'])?_c('div',{staticClass:"flex wrap align-center",staticStyle:{"width":"100%"}},[_c('pages',{key:"home",staticStyle:{"width":"100%"},attrs:{"pagetitle":"home"}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }